import { BuscaPassagensWidget } from '@/components/BuscaPassagensWidget';
export const frontmatter = {
  category: 'guia',
  title: 'Ilha do Mel - Itinéraire de 3 jours : Le guide idéal pour votre premier voyage',
  excerpt: 'L\'itinéraire complet pour une première visite à Ilha do Mel. Jour après jour, avec plages, sentiers de randonnée, restaurants et l\'incontournable excursion en bateau.',
  publishedAt: '2026-04-18',
  author: 'Guia Ilha do Mel',
  tags: ['roteiro', 'guia', 'primeira-viagem'],
  coverImage: '/images/sailboat.jpg',
  readingTime: '10 min',
};

# Itinéraire Ilha do Mel - 3 jours

L'île de Mel regorge de trésors ; **il est recommandé de prévoir au moins 3 jours** pour découvrir ses principaux attraits sans se presser. Cet itinéraire vous permettra de profiter des plages, des sentiers de randonnée, de l'histoire et de vous détendre.

**Conseil en or :** Réservez votre hébergement à l'avance, surtout pendant la haute saison (décembre à février).

---

Jour 1 — Arrivée et le sud de l'île (Encantadas)

Matin : Arrivée et installation

- Débarquement à l'embarcadère d'**Encantadas** ou de **Nova Brasília**

- Enregistrement à la maison d'hôtes et dépôt des bagages

- **Petit-déjeuner** à la maison d'hôtes (profitez des fruits régionaux)

Après-midi : Plage Encantadas

- Premier contact avec la mer : **Plage Encantadas**

- Eaux calmes, idéales pour une baignade relaxante

- Déjeuner à **End of the Trail** (réservation conseillée)

Fin d'après-midi : Grotte enchantée

- Randonnée facile de 15 minutes jusqu'à la **Grotte Enchantée**

- Lisez la légende de la grotte sur le panneau d'information

- Prenez des photos au coucher du soleil (la lumière dorée est incroyable)

Soirée : dîner et repos

- Dîner à l'auberge ou dans l'un des restaurants d'Encantadas

- **Couchez-vous tôt** — la deuxième journée est la plus intense.

---

Jour 2 — Nature et Histoire (Nova Brasília + Phare)

Matin : Phare de Conchas

- Petit-déjeuner matinal (7h)

- Sentier du Phare : ascension facile de 20 minutes

- Vue panoramique à 360° sur l’île depuis le sommet du phare

- **N’oubliez pas :** eau, crème solaire et chapeau

Après-midi : Plage de Farol + Fortaleza

- Descendez le sentier et profitez de la **plage de Farol**.

- Déjeuner à Nova Brasília.

- L'après-midi, visitez la **forteresse Notre-Dame des Plaisirs** (XVIIIe siècle).

Fin d'après-midi : Praia Grande ou Miguel

- Choisissez : **Praia Grande** (vaste, idéale pour les promenades) ou **Praia do Miguel** (intime, magnifique).

- Le coucher de soleil y est spectaculaire.

Nuit : étoiles et tranquillité

L'Ilha do Mel est peu touchée par la pollution lumineuse — **regardez le ciel**

Si vous êtes à Nova Brasília, profitez des bars avec musique live.

---

Jour 3 — Aventure et adieux

Matin : Excursion en bateau

Réservez le **Tour complet de l'île avec Carol** : une excursion en bateau pour découvrir l'île dans son intégralité.

Inclut la plongée avec tuba, des arrêts sur des plages isolées et des anecdotes locales.

Durée : 3 à 4 heures.

**Réservations :** Veuillez réserver à l’avance via WhatsApp. Il s’agit de l’excursion la plus populaire de l’île.

Après-midi : dernière baignade en mer

- Retournez au village où vous séjournez.

- Une dernière baignade sur votre plage préférée.

- Achetez des souvenirs dans les petites boutiques locales.

Fin d'après-midi : le coucher de soleil d'adieu

- La jetée **Encantadas** est l'endroit le plus romantique pour admirer le coucher du soleil.

- S'asseoir sur la jetée, les pieds dans l'eau.

Soirée : Dîner d'adieu

- Dîner spécial dans notre restaurant partenaire

- Prévoyez votre prochaine visite — car une seule visite ne suffit jamais !

---

Liste de vérification de l'itinéraire

- [ ] Réservation en chambre d'hôtes confirmée

- [ ] Visite à 360° prévue

- [ ] Espèces (pas de distributeur automatique)

- [ ] Lampe torche (pas d'éclairage public)

- [ ] Crème solaire et chapeau

- [ ] Chaussures de randonnée confortables

- [ ] Masque et tuba (ou location sur place)

---

Combien coûte cette visite?

| Article | Coût estimé |

| ---------------------------- | ----------------------- |

| Hébergement (2 nuits) | 300-700 R$ |

| Repas (3 jours) | 200-400 R$ |

| Visite à 360° | 150 R$/personne |

| Transport (aller-retour en bateau) | 44-77 R$ |

| **Total** | **700-1 300 R$/personne** |

<BuscaPassagensWidget />

---

Vous souhaitez personnaliser cet itinéraire ? Notre [guide complet de l’Ilha do Mel](/guide-complete) propose des variantes d’itinéraire pour 1, 2 et 3 jours, ainsi que des options budgétaires détaillées selon votre profil (budget, milieu de gamme et luxe).